class ComponentDropdown extends HTMLElement {
  connectedCallback() {
    this.toggleOuterButton = document.querySelector(
      `[data-dropdown-toggle="${this.dataset.target}"]`
    )
    this.toggleOuterButton?.addEventListener('click', (e) => {
      this.toggle(e)
    })
    this.toggleButton = this.querySelector('[data-toggle]')
    this.toggleButton?.addEventListener('click', (e) => {
      this.toggle(e)
    })
    this.addEventListener('click', (e) => {
      e.stopPropagation()
    })
    if (this.dataset.bodyClose) {
      const body = document.querySelector('body')
      body.addEventListener('click', () => {
        this.close()
      })
    }
  }

  disconnectedCallback() {
    this.toggleOuterButton = document.querySelector(
      `[data-dropdown-toggle="${this.dataset.target}"]`
    )
    this.toggleOuterButton?.removeEventListener('click', (e) => {
      this.toggle(e)
    })
    this.toggleButton = this.querySelector('[data-toggle]')
    this.toggleButton?.removeEventListener('click', (e) => {
      this.toggle(e)
    })
    if (this.dataset.bodyClose) {
      const body = document.querySelector('body')
      body.removeEventListener('click', () => {
        this.close()
      })
    }
  }

  toggle(e) {
    if (!this.classList.contains('active')) {
      this.closeGroupDropdown()
      e.currentTarget.setAttribute('aria-expanded', true)
    } else e.currentTarget.setAttribute('aria-expanded', false)
    this.classList.toggle('active')
  }

  close() {
    this.classList.remove('active')
    this.toggleButton?.setAttribute('aria-expanded', false)
    this.toggleOuterButton?.setAttribute('aria-expanded', false)
  }

  closeGroupDropdown() {
    this.groupDropdowns = document.querySelectorAll(
      `[data-group="${this.dataset.group}"]`
    )
    this.groupDropdowns.forEach((dropdown) => {
      dropdown.close()
    })
  }
}

customElements.define('component-dropdown', ComponentDropdown)
